import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, DialogActions, Button, CircularProgress
} from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import { updateSelicRates } from '../services/api';

interface Detalhamento {
    mesAno: string;
    valorGasto: number;
    taxaMes: number;
    jurosRs: number;
    saldoFinal: number;
}

interface ValoresCorrigidosModalProps {
    open: boolean;
    onClose: () => void;
    detalhamento: Detalhamento[];
    valorCorrigido: number;
    onRatesUpdated?: () => void;
}

const formatCurrency = (value: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
const formatPercent = (value: number) => new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

const ValoresCorrigidosModal: React.FC<ValoresCorrigidosModalProps> = ({ open, onClose, detalhamento, valorCorrigido, onRatesUpdated }) => {
    const [updating, setUpdating] = useState(false);

    const handleUpdateRates = async () => {
        setUpdating(true);
        try {
            await updateSelicRates();
            if (onRatesUpdated) {
                onRatesUpdated();
            }
        } catch (error) {
            console.error('Erro ao atualizar taxas:', error);
            alert('Erro ao atualizar taxas. Verifique o console.');
        } finally {
            setUpdating(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Detalhamento do Valor Corrigido
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={updating ? <CircularProgress size={20} /> : <SyncIcon />}
                    onClick={handleUpdateRates}
                    disabled={updating}
                >
                    {updating ? 'Atualizando...' : 'Atualizar Taxas'}
                </Button>
            </DialogTitle>
            <DialogContent>
                <Typography variant="h6" gutterBottom>Valor Total Corrigido: {formatCurrency(valorCorrigido)}</Typography>
                <TableContainer component={Paper}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Mês/Ano</TableCell>
                                <TableCell align="right">Valor Gasto</TableCell>
                                <TableCell align="right">Taxa (Mês)</TableCell>
                                <TableCell align="right">Juros (R$)</TableCell>
                                <TableCell align="right">Saldo Final</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {detalhamento.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.mesAno}</TableCell>
                                    <TableCell align="right">{formatCurrency(row.valorGasto)}</TableCell>
                                    <TableCell align="right">{formatPercent(row.taxaMes)}</TableCell>
                                    <TableCell align="right">{formatCurrency(row.jurosRs)}</TableCell>
                                    <TableCell align="right">{formatCurrency(row.saldoFinal)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ValoresCorrigidosModal;
